import React from 'react';

import { Invoice, invoiceColor } from 'helper/financial';
import EmailList from 'components/Admin/Financial/Invoices/Table/Row/EmailList';

import './index.scss';

export default function InvoiceCard({ invoice, selected, onToggle }: {
  invoice: Invoice,
  selected: boolean,
  onToggle: () => void,
}) {
  const {
    id, nfe, cnpj, corporateName, issueDate, dueDate, uf, city, url, tags, emails,
  } = invoice;
  const checkColor = invoiceColor(tags, emails);

  return (
    <div className={`financial-card${selected ? ' selected' : ''}`}>
      { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
      <label className="financial-card-select">
        <input
          id={`financial-card-check-${id}`}
          type="checkbox"
          checked={selected}
          onChange={onToggle}
          aria-label={`Selecionar NFe ${nfe}`}
        />
        <span className={`financial-card-check check-${checkColor}`} />
      </label>

      <div className="financial-card-body">
        <h3 className="financial-card-title">{`NFe ${nfe}`}</h3>
        <p className="financial-card-company">{corporateName}</p>
        <p className="financial-card-cnpj">{cnpj}</p>

        <dl className="financial-card-meta">
          <div>
            <dt>Emissão</dt>
            <dd>{issueDate}</dd>
          </div>
          <div>
            <dt>Vencimento</dt>
            <dd>{dueDate}</dd>
          </div>
          <div>
            <dt>Destino</dt>
            <dd>{`${uf} - ${city}`}</dd>
          </div>
        </dl>

        {tags.length > 0 && (
          <div className="financial-card-tags">
            {tags.map((tag) => (
              <span
                key={tag.id}
                className={`financial-card-tag ${tag.valid ? 'tag-green' : 'tag-red'}`}
              >
                {tag.text}
              </span>
            ))}
          </div>
        )}

        <div className="financial-card-emails">
          <span className="financial-card-emails-title">E-mails</span>
          <EmailList emails={emails} />
        </div>

        {url && (
          <a className="financial-card-link" href={url} target="_blank" rel="noreferrer">
            Abrir nota
          </a>
        )}
      </div>
    </div>
  );
}
